import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import classNames from '../../node_modules/classnames/index.js';
import { forwardRef, useCallback } from 'react';
import '@cheetahdigital/console-kit-cx';
import 'semantic-ui-react';
import 'react-dom';
import Clickable from '../../shared/elements/Clickable/index.js';
import NavbarLink from '../NavbarLink/index.js';
import styles from './index.module.scss.js';

var NavbarLinksItem = forwardRef(function (_a, ref) {
    var link = _a.link, _b = _a.onClick, onClick = _b === void 0 ? function () { return ({}); } : _b;
    var label = link.label, isActive = link.isActive, isHidden = link.isHidden, isDisabled = link.isDisabled, isDisableUnderline = link.isDisableUnderline, className = link.className, style = link.style, icon = link.icon;
    var handleClick = useCallback(function () {
        if (link.isDisabled)
            return;
        if (onClick)
            onClick(link);
    }, [link, onClick]);
    return (jsx("div", __assign({ ref: ref, className: classNames("navbarLinksItem", styles.navbarLinksItem) }, { children: !isHidden && (jsx(Clickable, __assign({ onClick: handleClick }, { children: jsx(NavbarLink, __assign({ isActive: isActive, isDisabled: isDisabled, isDisableUnderline: isDisableUnderline, className: className, style: style, icon: icon }, { children: label }), void 0) }), void 0)) }), void 0));
});
NavbarLinksItem.displayName = "NavbarLinksItem";

export { NavbarLinksItem as default };
